import { memo } from 'react';
import NavigationHeaderWapper from '@/sub-luca-plugin/components/navigation-header-wapper';
import CollectAction from '@/sub-luca-plugin/components/collect-action';
import { Markdown } from '@/sub-luca-plugin/compatible-components';
import { TOnCollectStatusChange } from '@/sub-luca-plugin/types';
import './index.scss';

export interface IKnowledgePointsRenderProps {
    title?: string;
    content?: string;
    recordId?: string;
    projectId?: number;
    subjectId?: number;
    twoLevelSubjectId?: number;
    onClose?: () => void;
    onCollectStatusChange?: TOnCollectStatusChange;
}

const KnowledgePointsRender = ({
    recordId,
    title = '',
    content = '',
    projectId,
    subjectId,
    twoLevelSubjectId,
    onClose,
    onCollectStatusChange,
}: IKnowledgePointsRenderProps) => {
    return (
        <div className="knowledge-points-drawer__container">
            <NavigationHeaderWapper onClose={onClose}>
                <div className="knowledge-points-drawer__header-title">知识切片</div>
                {recordId && (
                    <CollectAction
                        type="resource"
                        id={recordId}
                        projectId={projectId}
                        subjectId={subjectId}
                        twoLevelSubjectId={twoLevelSubjectId}
                        needToastInQa
                        onChange={onCollectStatusChange}
                    />
                )}
            </NavigationHeaderWapper>
            <div className="knowledge-points-drawer__content-scroll-container">
                <div className="knowledge-points-drawer__content">
                    <div className="knowledge-points-drawer__title">{title}</div>
                    <div className="knowledge-points-drawer__markdown-container">
                        <Markdown content={content} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(KnowledgePointsRender);
